export default __webpack_public_path__ + "static/media/seg-0-artist.dd4fe1bd.png";